module.exports = __webpack_public_path__ + "img/23-r.aed45b56.png";